import styled from '@emotion/styled';
import { CircularProgress } from '@mui/material';
import tw from 'twin.macro';

const StyledCircularProgress = styled(CircularProgress)(() => [
  tw`text-brand-300`,
]);

export const Loader = ({
  size = 48,
  message = 'Loading results. Please wait',
}) => (
  <div className="flex justify-center items-center flex-col gap-3">
    <StyledCircularProgress size={size} />
    {message && (
      <span className="text-base-800 text-[16px]/[24px] -tracking-[.01em]">
        {message}
      </span>
    )}
  </div>
);
